window.addEventListener('klaviyoForms', function (e) {
  if (e.detail.type !== 'open') return;

  let attempts = 0;
  const maxAttempts = 20;

  const timer = setInterval(() => {
    attempts++;

    const dialog = document.querySelector('[role="dialog"][aria-label="POPUP Form"]');
    if (!dialog) {
      if (attempts >= maxAttempts) clearInterval(timer);
      return;
    }

    // If focus is already inside the popup, let Klaviyo keep control
    if (dialog.contains(document.activeElement)) {
      clearInterval(timer);
      return;
    }

    const buttons = Array.from(dialog.querySelectorAll('button[type="button"], button'));

    const ctaButton = buttons.find((button) => {
      const text = button.textContent?.trim().toLowerCase();
      return text === 'yes please!';
    });

    const closeButton = dialog.querySelector('button[aria-label="Close dialog"]');
    const target = ctaButton || closeButton;

    if (target) {
      target.focus({ preventScroll: true });

      if (dialog.contains(document.activeElement)) {
        clearInterval(timer);
      }
    }

    if (attempts >= maxAttempts) {
      clearInterval(timer);
    }
  }, 100);
});
